<template>
  <div id="app">
    <router-view/>
  </div>
</template>

<script>
  export default {
    name: 'App'
  }
</script>

<style>
  #app {
    background: #f2f2f2;
    min-width: 1024px;
    padding:20px 10px;
    box-sizing: border-box;
    font-family: 微软雅黑;
  }
</style>



// WEBPACK FOOTER //
// src/App.vue